import axios from 'axios';
import socket from '../../events/socket-connect';

const state = {
  refresh_id: null,
  config: {},
  data: {
    id: null,
    email: '',
    empresa: {},
    permissoes: []
  },
  localSettings: {
    user_language: 'pt_BR',
    user_skin: 'skin-blue-light',
    box: 'box-primary',
    btn: 'btn-primary',
    tab: 'tab-primary',
    nav: 'navbar-primary',
    layout: {},
  },
  select: [],
  index: [],
  orderables: [{
      title: 'Nome',
      name: 'nome'
    },
    {
      title: 'Documento',
      name: 'documento'
    },
    {
      title: 'Cadastrado em',
      name: 'created_at'
    }
  ],
  filterGroups: [{
    name: 'Usuario',
    filters: [{
        title: 'Nome',
        name: 'nome',
        type: 'string'
      },
      {
        title: 'Documento',
        name: 'documento',
        type: 'document'
      },
      {
        title: 'Email',
        name: 'email',
        type: 'string'
      },
      {
        title: 'Cadastrado em',
        name: 'created_at',
        type: 'datetime'
      }
    ]
  }]
};

const mutations = {
  UPDATE_USER_LIST: (state, payload) => {
    let test = state.index.findIndex(x => x.id == payload);
    state.index[test].status = !state.index[test].status;
  },
  SET_USER: (state, payload) => {
    state.data = payload;
    if (!state.data.empresa) {
      state.data.empresa = {}
      state.data.permissions = []
    }
  },
  SET_LAYOUT: (state, payload) => {
    state.localSettings.layout.box = `box-${payload}`;
    state.localSettings.layout.btn = `btn-${payload}`;
    state.localSettings.layout.tab = `card-${payload}`;
    state.localSettings.layout.card = `card-${payload}`;
    state.localSettings.layout.nav = `navbar-${payload}`;
    state.localSettings.layout.check = `${payload}`;
    state.localSettings.layout.theme = `${payload}`;
  },
  CHANGE_LANGUAGE: (state, payload) => {
    state.localSettings.user_language = payload;
  },
  CHANGE_USER_SKIN: (state, payload) => {
    state.localSettings.user_skin = payload;
  },
  SET_USER_SELECT: (state, payload) => {
    state.select = payload;
  },
  SET_USERS: (state, payload) => {
    state.index = payload;
  },
  SET_USER_CONFIG: (state, payload) => {
    state.config = payload;
  }
};
const actions = {
  getUserData: (context) => {
    return axios.get('/api/participant/user')
      .then((response) => {
        if (response.data.status !== 401) {
          context.commit('SET_USER', response.data);
        }
        return response;
      }).then(response => {
        if (response.data.status !== 401) {
          socket.socketConnect();
        }
      })
      .catch(error => {
        console.log('erro ao pegar dados do usuário', error);
        return error;
      });
  },   
  previewNotification: (context, payload) => {
    return axios.put(`/api/participant/notification/${payload}/show`).then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  previewAllNotification: () => {
    return axios.put('/api/participant/notifications/show').then(response => {
      return response.data;
    }).catch(error => {
      return error.response;
    });
  },
  deleteNotificationById: (context, payload) => {
    return axios.delete(`/api/participant/notification/${payload}`).then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  deleteAllNotifications: () => {
    return axios.delete('/api/participant/notifications').then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  changeLanguage: (context, payload) => {
    return axios.put(`/api/usuario/change-language/${payload}`).then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  changeUserSkin: (context, payload) => {
    axios.put(`/api/usuario/change-skin/${payload}`).then(() => {}).catch(error => {
      console.log(error.response.data);
    });
  },
  changePassword: (context, payload) => {
    return axios.put('/api/participant/password/', payload).then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  updateUser: (context, payload) => {
    return axios.put('/api/particpant', payload).then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  }, 
  getEula: (context, payload) => {
    return axios.get('/api/eula').then(response => {
      return response.data;
    }).catch(error => {
      return error.response.data;
    });
  },
  generateGoogleSecret: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.get('/api/participant/otp')
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  changeTwoFactory: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.put('/api/participant/change-two-factory', payload)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  getConfig: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.get(`/api/config/${payload}`)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  buyTicket: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.post(`/api/cupom/${payload}/buy`)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  saveProfile: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.put(`/api/participant-profile`, payload)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  incrementClickCupom: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.post(`/api/cupom/${payload}/click`)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
  getSalesHistory: (context, payload) => {
    let promise = new Promise((resolve, reject) => {
     axios.get(`/api/sales-history`)
      .then(response => {
         resolve(response.data);
      }).catch(error => {
         reject(error.response.data);
      });
    });
    return promise;
  },
};

export default {
  state,
  mutations,
  actions
};